import adminAPIs from "apis/AdminApis";
import useUploadImage from "hooks/imageContext";
import { useEffect, useState } from "react";
const base_URL = process.env.REACT_APP_API_BASE_URL;

function ManageFeed() {
  const [feeds, setFeeds] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingFeed, setEditingFeed] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const { uploadImage, loading: uploading, data: imageData } = useUploadImage();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    media_url: "",
      date_conducted: "",
    place: "",
    feed_type: "meetup",
    isVisible: true,
  });

  useEffect(() => {
    fetchFeeds();
  }, []);

  const fetchFeeds = async () => {
    setLoading(true);
    try {
      const data = await adminAPIs.allFeeds();

      console.log(data?.data?.data?.feeds);
      setFeeds(data?.data?.data?.feeds);
    } catch (err) {
      setError("Failed to load feeds");
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (files) {
      try {
        const data = await uploadImage(files, "Feeds");
        console.log(data);
        const media = uploadedImages ? [...uploadedImages, ...data?.data] : [data?.data];

        setUploadedImages(media);
        setFormData((prev) => ({ ...prev, media_url: [...data?.data, ...uploadedImages] }));
      } catch (err) {
        console.log(err);
        setError("Failed to upload media");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(formData);
    try {
      const feedRes = await adminAPIs.upsertFeed(formData);
      console.log(feedRes);
      if (editingFeed) {
        setFeeds((prev) =>
          prev.map((feed) => (feed.id === editingFeed.id ? { ...feed, ...formData } : feed))
        );
      } else {
        setFeeds((prev) => [...prev, { ...formData, id: Date.now() }]);
      }
      fetchFeeds();
      setSuccess("Feed successfully saved!");
      setIsModalOpen(false);
      resetForm();
    } catch (err) {
      console.log(err);
      setError("Failed to save feed");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (feed) => {
    console.log(feed);
    setFormData(feed);
    setUploadedImages([...feed?.media_url]);
    setIsModalOpen(true);
  };

  const resetForm = () => {
    setFormData({
      title: "",
      description: "",
      media_url: "",
      date_conducted: "",
      feed_type: "meetup",
      isVisible: true,
    });
    setEditingFeed(null);
    setUploadedImages([]);
  };

  const handleHide = async (feedId, show) => {
    if (confirm("Are you sure you want to hide this feed? This action cannot be undone.")) {
      setLoading(true);
      try {
        await adminAPIs.hideFeed(feedId, show);
        await fetchFeeds();
        setSuccess("Feed successfully deleted!");
      } catch (err) {
        setError("Failed to delete feed");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDelete = async (feedId) => {
    if (confirm("Are you sure you want to delete this feed? This action cannot be undone.")) {
      setLoading(true);
      try {
        await adminAPIs.deleteFeed(feedId);
        await fetchFeeds();
        setSuccess("Feed successfully deleted!");
      } catch (err) {
        console.log(err);
        setError("Failed to delete feed");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 font-inter">Alumni Feed Management</h1>
          <p className="mt-2 text-gray-600">Create and manage updates for the alumni community</p>
        </div>
        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-gradient-to-r from-[#D4AF37] to-[#C5A028] text-white px-6 py-3 rounded-lg
                       font-medium transition-all duration-300 flex items-center gap-2 hover:from-[#C5A028] hover:to-[#B69020]"
        >
          <i className="fas fa-plus"></i>
          Create New Feed
        </button>
      </div>

      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-600">
          <i className="fas fa-exclamation-circle mr-2"></i>
          {error}
        </div>
      )}

      {success && (
        <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg text-green-600">
          <i className="fas fa-check-circle mr-2"></i>
          {success}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {loading
          ? [...Array.from({ length: 6 })].map((_, i) => (
              <div key={i} className="bg-white rounded-xl shadow-md p-4 animate-pulse">
                <div className="w-full h-48 bg-gray-200 rounded-lg mb-4"></div>
                <div className="h-6 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
                <div className="flex justify-between items-center">
                  <div className="h-8 bg-gray-200 rounded w-24"></div>
                  <div className="h-8 bg-gray-200 rounded w-24"></div>
                </div>
              </div>
            ))
          : feeds.map((feed) => (
              <div
                key={feed.id}
                className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
              >
                {feed.media_url[0] && (
                  feed.media_url[0].toLowerCase().endsWith('.mp4') ||
                  feed.media_url[0].toLowerCase().endsWith('.mov') ||
                  feed.media_url[0].toLowerCase().endsWith('.avi') ? (
                    <video
                      src={base_URL + "/get-image?objectKey=" + feed.media_url[0]}
                      className="w-full h-48 object-cover rounded-t-xl"
                      controls
                    />
                  ) : (
                    <img
                      src={base_URL + "/get-image?objectKey=" + feed.media_url[0]}
                      alt={feed.title}
                      className="w-full h-48 object-cover rounded-t-xl"
                    />
                  )
                )}
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-medium ${
                        feed.feed_type === "meetup"
                          ? "bg-[#D4AF37]/10 text-[#D4AF37]"
                          : "bg-blue-50 text-blue-600"
                      }`}
                    >
                      {feed?.feed_type?.charAt(0).toUpperCase() + feed?.feed_type?.slice(1)}
                          </span>
                          {feed?.place && <span
                              className={`px-3 py-1 rounded-full text-sm font-medium  bg-blue-50 text-blue-600
                      }`}
                          >
                              {feed?.place?.toUpperCase()}
                          </span>}
                    <span className="text-gray-500 text-sm">
                      {new Date(feed.date_conducted).toLocaleDateString()}
                    </span>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">{feed.title}</h3>
                  <p className="text-gray-600 text-sm line-clamp-2 mb-4">{feed.description}</p>
                  <div className="flex justify-between items-center">
                    <button
                      onClick={() => handleEdit(feed)}
                      className="text-blue-600 hover:text-blue-700 transition-colors duration-200"
                    >
                      <i className="fas fa-edit mr-1"></i>
                      Edit
                    </button>
                    {feed?.show ? (
                      <button
                        onClick={() => handleHide(feed.id, feed.show)}
                        className="text-red-600 hover:text-red-700 transition-colors duration-200"
                      >
                        <i className="fas fa-eye mr-1"></i>
                        Hide
                      </button>
                    ) : (
                      <button
                        onClick={() => handleHide(feed.id, feed.show)}
                        className="text-blue-600 hover:text-blue-700 transition-colors duration-200"
                      >
                        <i className="fas fa-eye mr-1"></i>
                        Show
                      </button>
                    )}
                    <button
                      onClick={() => handleDelete(feed.id)}
                      className="text-red-600 hover:text-red-700 transition-colors duration-200"
                    >
                      <i className="fas fa-trash-alt mr-1"></i>
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-semibold text-gray-900">
                {editingFeed ? "Edit Feed" : "Create New Feed"}
              </h2>
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  resetForm();
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-gray-700 font-medium mb-2">Title</label>
                <input
                  type="text"
                  required
                  value={formData.title}
                  onChange={(e) => setFormData((prev) => ({ ...prev, title: e.target.value }))}
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:outline-none"
                  placeholder="Enter feed title"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">Description</label>
                <textarea
                  required
                  value={formData.description}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:outline-none h-32"
                  placeholder="Enter feed description"
                ></textarea>
                          </div>
                          <div>
                <label className="block text-gray-700 font-medium mb-2">Place</label>
                          <input
                  type="text"
                  required
                  value={formData.place}
                  onChange={(e) => setFormData((prev) => ({ ...prev, place: e.target.value }))}
                  className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:outline-none"
                  placeholder="Enter place"
                              />
                              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-2">Media</label>
                <div className="flex items-center gap-4">
                  <input
                    type="file"
                    multiple
                    accept="image/*,video/*"
                    onChange={handleImageUpload}
                    className="hidden"
                    id="image-upload"
                  />
                  <label
                    htmlFor="image-upload"
                    className="px-4 py-2 bg-blue-50 text-blue-600 rounded-lg cursor-pointer hover:bg-blue-100 transition-colors duration-200"
                  >
                    <i className="fas fa-upload mr-2"></i>
                    Choose Media
                  </label>
                  {uploadedImages.length > 0 && (
                    <div className="flex flex-wrap items-center gap-2">
                      {uploadedImages.map((media, index) => (
                        <div key={index} className="relative group">
                          {media.toLowerCase().endsWith('.mp4') || 
                           media.toLowerCase().endsWith('.mov') || 
                           media.toLowerCase().endsWith('.avi') ? (
                            <div className="relative">
                              <video
                                src={`${base_URL}/get-image?objectKey=${media}`}
                                className="h-20 w-20 object-cover rounded-lg"
                                playsInline
                                muted
                                controls={false}
                                preload="metadata"
                              >
                                <source src={`${base_URL}/get-image?objectKey=${media}`} type="video/mp4" />
                                Your browser doesn't support video playback.
                              </video>
                              <div className="absolute inset-0 flex items-center justify-center">
                                <i className="fas fa-play text-white text-xl"></i>
                              </div>
                            </div>
                          ) : (
                            <img
                              src={`${base_URL}/get-image?objectKey=${media}`}
                              alt={`Uploaded Media ${index + 1}`}
                              className="h-20 w-20 object-cover rounded-lg"
                            />
                          )}
                          <button
                            onClick={() => {
                              const newImages = uploadedImages.filter((_, i) => i !== index);
                              setUploadedImages(newImages);
                              setFormData(prev => ({ ...prev, media_url: newImages }));
                            }}
                            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-red-600"
                          >
                            <i className="fas fa-times text-xs"></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-gray-700 font-medium mb-2">Date & Time</label>
                  <input
                    type="datetime-local"
                    required
                    value={formData.date_conducted ? new Date(formData.date_conducted).toISOString().slice(0, 16):null}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        date_conducted: e.target.value,
                      }))
                    }
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:outline-none"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">Feed Type</label>
                  <select
                    value={formData.feed_type}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        feed_type: e.target.value,
                      }))
                    }
                    className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:outline-none"
                  >
                    <option value="meetup">Meetup</option>
                                      <option value="information">Information</option>
                                      <option value="achievement">Achievement</option>
                  </select>
                </div>
              </div>

              <div className="flex justify-end gap-4 mt-8">
                <button
                  type="button"
                  onClick={() => {
                    setIsModalOpen(false);
                    resetForm();
                  }}
                  className="px-6 py-3 bg-gray-50 text-gray-600 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-6 py-3 bg-gradient-to-r from-[#D4AF37] to-[#C5A028] text-white rounded-lg font-medium hover:from-[#C5A028] hover:to-[#B69020] transition-all duration-300 flex items-center gap-2"
                >
                  {loading ? (
                    <>
                      <i className="fas fa-circle-notch fa-spin"></i>
                      {editingFeed ? "Updating..." : "Creating..."}
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save"></i>
                      {editingFeed ? "Update Feed" : "Create Feed"}
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default ManageFeed;
